/**
 * ProtectedRoute.tsx — auth gate.
 *
 * If no access token (or no user profile yet) we send the visitor to /login.
 * The location they wanted is preserved in router state so the login page
 * can bounce them back after a successful sign-in.
 */

import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAppSelector } from '../redux/hooks';
import { selectIsAuthed } from '../redux/slices/auth';

export default function ProtectedRoute() {
	const authed = useAppSelector(selectIsAuthed);
	const location = useLocation();
	if (!authed) {
		return <Navigate to="/login" replace state={{ from: location.pathname }} />;
	}
	return <Outlet />;
}
